import { createSelector } from "@ngrx/store";
import { AppCRMState } from "./app.state";

export const getCRMFeatureState = (state: AppCRMState) => state.crmState;

// app state
export const companySelector = createSelector(
  getCRMFeatureState,
  (state) => state.company
);

export const userSelector = createSelector(
  getCRMFeatureState,
  (state) => state.user
);

// attendance
export const isLoadingSelector = createSelector(
  getCRMFeatureState,
  (state) => state.isLoading
);

export const funnelSelector = createSelector(
  getCRMFeatureState,
  (state) => state.funnel
);

export const funnelsSelector = createSelector(
  getCRMFeatureState,
  (state) => state.funnels
);

export const stagesSelector = createSelector(
  getCRMFeatureState,
  (state) => state.stages
);

export const stageSelector = createSelector(
  getCRMFeatureState,
  (state) => state.stage
);

export const cardsSelector = createSelector(
  getCRMFeatureState,
  (state) => state.cards
);

export const cardSelector = createSelector(
  getCRMFeatureState,
  (state) => state.card
);

export const errorSelector = createSelector(
  getCRMFeatureState,
  (state) => state.error
);

export const queryParamsSelector = createSelector(
  getCRMFeatureState,
  (state) => state.queryParams
);

